import BaggageRetryButton from '@/src/components/common/ui/BaggageRetryButton'
import { Box, Skeleton, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'

interface ProcessedBaggageData {
    checkIn: string | null
    cabin: string | null
}

interface BaggageSectionProps {
    processedBaggageData: ProcessedBaggageData | null
    isLoading: boolean
    retryCount?: number
    maxRetries?: number
    onRetryBaggage?: () => void
}

export const BaggageSection: React.FC<BaggageSectionProps> = ({
    processedBaggageData,
    isLoading,
    retryCount = 0,
    maxRetries = 2,
    onRetryBaggage
}) => {
    const shouldShowRetry =
        (!processedBaggageData || (!processedBaggageData.checkIn && !processedBaggageData.cabin)) &&
        !isLoading &&
        retryCount < maxRetries &&
        onRetryBaggage
    const tFlightDetails = useTranslations('srpFlightDetails')
    const tCommon = useTranslations('common')
    return (
        <Box
            sx={{
                backgroundColor: '#FFF',
                display: 'flex'
            }}
        >
            <Box
                sx={{
                    pt: 3,
                    pl: 2,
                    pr: 1,
                    flex: 1,
                    borderRight: '1px solid',
                    borderColor: 'grey.200'
                }}
            >
                <Typography sx={{ fontWeight: 600, fontSize: { sm: 14, md: 16 } }}>{tCommon('baggage')}</Typography>
            </Box>

            <Box sx={{ flex: 2, py: 2, px: 2, gap: 1, display: 'flex', flexDirection: 'column' }}>
                {isLoading ? (
                    <>
                        <Skeleton variant="text" width={150} height={20} sx={{ mx: 'auto' }} />
                        <Skeleton variant="text" width={150} height={20} sx={{ mx: 'auto' }} />
                    </>
                ) : shouldShowRetry ? (
                    <BaggageRetryButton onRetry={onRetryBaggage} boxSx={{ textAlign: 'center' }} />
                ) : processedBaggageData && (processedBaggageData.checkIn || processedBaggageData.cabin) ? (
                    <>
                        <Box display="flex" justifyContent={'space-between'}>
                            <Typography variant="body2" color="grey.500" sx={{ fontSize: { sm: 12, md: 14 } }}>
                                {tCommon('checkin')}
                            </Typography>
                            <Typography variant="body2" fontWeight={500} sx={{ fontSize: { sm: 12, md: 14 } }}>
                                {processedBaggageData.checkIn || '-'}
                            </Typography>
                        </Box>
                        <Box display="flex" justifyContent={'space-between'}>
                            <Typography variant="body2" color="grey.500" sx={{ fontSize: { sm: 12, md: 14 } }}>
                                {tCommon('cabinBaggage')}
                            </Typography>
                            <Typography variant="body2" fontWeight={500} sx={{ fontSize: { sm: 12, md: 14 } }}>
                                {processedBaggageData.cabin || '-'}
                            </Typography>
                        </Box>
                    </>
                ) : (
                    <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
                        {tFlightDetails('baggageFailureNote')}
                    </Typography>
                )}
            </Box>
        </Box>
    )
}
